import React from 'react';
import {
  Box,
  Typography,
  Paper,
  useTheme,
  Link,
} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import ContactForm from '../components/ContactForm';
import { useLanguage } from '../contexts/LanguageContext';

const Contact: React.FC = () => {
  const theme = useTheme();
  const { t } = useLanguage();

  return (
    <Box sx={{ py: 8 }}>
      <Paper
        elevation={0}
        sx={{
          p: 6,
          textAlign: 'center',
          background: `linear-gradient(135deg, ${theme.palette.primary.light}15 0%, ${theme.palette.secondary.light}15 100%)`,
          borderRadius: 4,
          mb: 8,
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          gutterBottom
          color="primary"
          sx={{ fontWeight: 700 }}
        >
          {t('contact.title')}
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          paragraph
          sx={{ mb: 4, maxWidth: '800px', mx: 'auto' }}
        >
          {t('contact.subtitle')}
        </Typography>
      </Paper>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 2fr',
          },
          gap: 4,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            height: '100%',
            background: `linear-gradient(135deg, ${theme.palette.primary.light}10 0%, ${theme.palette.secondary.light}10 100%)`,
            borderRadius: 4,
          }}
        >
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            color="primary"
            sx={{ fontWeight: 600 }}
          >
            {t('contact.info.title')}
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t('contact.info.email')}
            </Typography>
            <Typography variant="body1" paragraph>
              crafticore@gmail.com
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t('contact.info.instagram')}
            </Typography>
            <Link
              href="https://www.instagram.com/crafticore3d/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              <InstagramIcon />
              <Typography variant="body1">
                @crafticore3d
              </Typography>
            </Link>
          </Box>
        </Paper>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            background: `linear-gradient(135deg, ${theme.palette.primary.light}10 0%, ${theme.palette.secondary.light}10 100%)`,
            borderRadius: 4,
          }}
        >
          <ContactForm />
        </Paper>
      </Box>
    </Box>
  );
};

export default Contact; 